export const findEditDocOptionValue = (id, option) => {
    if (id === undefined) {
        return "";
    } else {
        const findArr = option.find(el => el.value === id);
        return JSON.parse(JSON.stringify(findArr).replaceAll('"value"', '"id"').replaceAll('"label"', '"name"'))
    }
}

